var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 1.33301H5.33301C2.66634 1.33301 1.33301 2.66634 1.33301 5.33301V13.9997C1.33301 14.3663 1.63301 14.6663 1.99967 14.6663H10.6663C13.333 14.6663 14.6663 13.333 14.6663 10.6663V5.33301C14.6663 2.66634 13.333 1.33301 10.6663 1.33301Z",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60685 5.22677L5.14685 8.68677C5.01352 8.8201 4.88686 9.0801 4.86019 9.26677L4.67353 10.5868C4.60686 11.0668 4.94019 11.4001 5.42019 11.3334L6.74018 11.1468C6.92684 11.1201 7.18686 10.9934 7.32019 10.8601L10.7802 7.4001C11.3735 6.80677 11.6602 6.11343 10.7802 5.23343C9.90019 4.34677 9.20685 4.62677 8.60685 5.22677Z",
    stroke: "#5A6385",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11328 5.71973C8.40661 6.76639 9.22661 7.59306 10.2799 7.88639",
    stroke: "#5A6385",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteNote);
export default __webpack_public_path__ + "static/media/write-note.5001217357ac5680ca76173e4366182b.svg";
export { ForwardRef as ReactComponent };